import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LangProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/site/Layout";
import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServiceDetail from "@/pages/ServiceDetail";
import Expertise from "@/pages/Expertise";
import Realisations from "@/pages/Realisations";
import ContactPage from "@/pages/ContactPage";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";
import ProtectedRoute from "@/auth/ProtectedRoute";
import { CookieConsent } from "@/components/site/CookieConsent";
import { getConsent, loadGA } from "@/lib/analytics";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<ServicesIndex />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/expertise" element={<Expertise />} />
        <Route path="/realisations" element={<Realisations />} />
        <Route path="/contact" element={<ContactPage />} />
      </Route>
      <Route path="/login" element={<Login />} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
    document.documentElement.lang = "fr";
    if (getConsent() === "granted") loadGA();
  }, []);
  return (
    <LangProvider>
      <BrowserRouter>
        <AppRouter />
        <CookieConsent />
        <Toaster position="bottom-right" theme="dark" />
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
